'use strict';

module.exports = syr2;

function syr2 () {
  console.error('SYR (symmetric rank 2 operation A := alpha*x*y\' + alpha*y*x\' + A) not yet implemented');
}
